<template>
    <v-container>
        <v-data-table dense :headers="statusHeaders" :items="history" hide-default-footer :items-per-page="-1">
            <template v-slot:[`item.StartDate`]="{ item }">
              <span>{{ displayDate(new Date(item.StartDate)) }}</span>
            </template>
            <template v-slot:[`item.EndDate`]="{ item }">
              <span>{{ displayDate(new Date(item.EndDate)) }}</span>
            </template>
        </v-data-table>
    </v-container>
</template>
<script>
import Utils from '@/utils.js';

export default {
  name: 'statusHistory',
   props: {
    history: [],
  },
  data: () => ({
      statusHeaders:[
          {text:'Description',value:'Description'},
          {text:'Start Date', value:'StartDate'},
          {text:'End Date', value:'EndDate'},
          {text:'Status', value:'Status'},
          ],
  }),
  methods: {
   displayDate(date) {
      if (date.getFullYear() <= 1900) return null;
      return Utils.getDateStr(date);
    },
  }
}
  </script>